import React from 'react';
import CusLabelSelect from '../material-ui/CusLabelSelect';
import { useAppSelector } from '../../store';
import ShowContainer from '../material-ui/ShowContainer';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { timezones } from '../../enums/enums';
import CusTooltip from '../material-ui/CusTooltip';

export default function TimeZone({ groupId, tzOffset, label = 'Group time zone', hideTooltip }) {
  const { t } = useTranslation();
  const group = useAppSelector((state) => state.user.group.hash?.[groupId]);
  const cusTzOffset = tzOffset ?? group?.tzOffset;
  const timeZone = timezones.find((el) => el.value == cusTzOffset)?.label;

  return (
    <ShowContainer condition={timeZone}>
      <Box>
        <Stack display={'flex'} gap={0.5} direction={'row'}>
          <Typography variant="body1">
            {t(label)} : <b>{timeZone}</b>
          </Typography>
          <ShowContainer condition={!hideTooltip}>
            <CusTooltip text={'Time zone according to the current group settings.'} />
          </ShowContainer>
        </Stack>
      </Box>
    </ShowContainer>
  );
}
